import React from 'react';
import NotFoundView from '../Common/Components/NotFoundView.jsx';
import AuthsSignInPageView from './SignIn/Components/AuthsSignInPageView';
import RecoverAccountPageView from './RecoverAccount/Components/RecoverAccountPageView.jsx';
import ResetPasswordPageView from './ResetPassword/Components/ResetPasswordPageView.jsx';
import { home } from "../Common/Routes/LegacyBreadcrumbs.js";
import { Route, Routes } from 'react-router-dom-v5-compat';
import { WrappingRoute } from '../Common/Components/Routes/WrappingRoute';

export default (
    <Routes>
        <Route element={<WrappingRoute title="Log in"/>}>
            <Route path="/App/Auths/LogIn" element={ <AuthsSignInPageView /> } />
        </Route>
        <Route element={<WrappingRoute title="Recover account"/>}>
            <Route path="/App/Auths/RecoverAccount" element={ <RecoverAccountPageView/> } />
        </Route>
        <Route element={<WrappingRoute title="Reset password"/>}>
            <Route path="/App/Auths/ResetPassword" element={ <ResetPasswordPageView /> } />
        </Route>
        <Route element={<WrappingRoute title="Not found" breadcrumbs={ [home] } />}>
            <Route element={ <NotFoundView /> } />
        </Route>
    </Routes>
);
